/**
 * Client-side failures that aren't app bugs. Reporting them buried the real
 * crashes (SUPPORT-839):
 *
 * - 401s: the session expired and the page is already on its way to /login.
 * - Network errors and timeouts: no answer came back. Server-side p95 on the
 *   busiest endpoints is under 3s, so these are the member's connection, and
 *   bootstrap.js has already retried once and shown a toast.
 */
export function isExpectedClientError(error) {
    // Inertia's own client reports a dropped connection this way.
    if (error?.name === 'HttpNetworkError') {
        return true;
    }

    if (!error?.isAxiosError) {
        return false;
    }

    return (
        error.response?.status === 401 ||
        ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code)
    );
}

/**
 * Sentry `beforeSend`: drop the expected client failures above.
 */
export function dropExpectedClientErrors(event, hint) {
    return isExpectedClientError(hint?.originalException) ? null : event;
}

/**
 * Sentry `ignoreErrors` entries for errors raised by link scanners and
 * in-app browsers rather than by our code.
 */
export const IGNORED_CLIENT_ERROR_MESSAGES = [
    'Object Not Found Matching Id', // Outlook Safe Links scanner
    'WKWebView API client did not respond', // iOS in-app browsers
    'Object captured as promise rejection with keys: [object has no keys]',
];
